// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../Assest/Svg/DashboardWelcomeImg.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card_O2mpS {
  margin-top: 10px;
  width: 100%;
}
.cardContent_Q7qC4 {
  margin: -10px;
}
.col_nrFxf {
  display: flex;
  flex-direction: column;
}
.marginTop10_XhSDp {
  margin-top: 10px;
}
.marginTop5_Z7qm_ {
  margin-top: 5px;
}
.marginRight10_mqLc4 {
  margin-right: 10px;
}
.marginLeft10_CYZrh {
  margin-left: 10px;
}
.displayflex_ltmqi {
  display: flex;
}
.tittle_Yy0HQ {
  font-size: 24px;
  font-weight: 600;
  color: #3a3541;
  margin-top: 0px;
}
.textAlignRight_hE5Na {
  text-align: right;
}
.welcome_ESNDi {
  justify-content: space-between;
}
.welcome__div_YGwMa {
  display: flex;
  flex-direction: row;
  margin-top: 0px;
  font-size: 18px;
  margin-bottom: 5px;
}
.welcome__div__largeText_DVK_0 {
  font-size: 18px;
  color: #000000;
  font-weight: 600;
  margin: auto;
}
.welcome__div__largeText_name_tJ4AY {
  font-size: 18px;
  color: #3e8eff;
  font-weight: 400;
}
.welcome__div__smallText_bXrSy {
  font-size: 14px;
  color: #000000;
  font-weight: 500;
  margin: auto;
}
.headLines__left_cW4Gw {
  background-color: #2c4360;
  border-radius: 10px;
}
.headLines__left__textDivOne_xM6uV {
  width: 100%;
  margin-left: 10px;
}
.headLines__left__textDiv__backgroundImage_vbp04 {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat -75% 140%;
  height: 100%;
  width: 100%;
}
.headLines__left__textDivOne_text_ieOIV {
  font-weight: 500;
  font-size: 16px;
  color: #ffffff;
}
.headLines__left__textDivTwo_x4kVi {
  width: 100%;
  margin-left: 10px;
  margin-top: -10px;
}
.headLines__left__textDivTwo_text_gGk8L {
  font-weight: 500;
  font-size: 12px;
  color: #ffffff;
  text-align: justify;
}
.headLines__left__textDivOne__text__name_YBot4 {
  font-weight: 700;
  color: #ffc061;
}
.headLines__right_NdZp_ {
  max-height: 124px;
}
.headLines__right__row_kDro5 {
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;
  margin-left: 20px;
  margin-bottom: 0px;
}
.headLines__right__row__headline_p52ez {
  font-size: 20px;
  font-weight: 600;
  margin-top: 0px;
  margin-bottom: 0px;
  color: #25396f;
  line-height: 32px;
}
.headLines__right__row__headline__arrow_B8g8R {
  position: absolute;
  right: 0px;
  top: 2px;
}
.headLines__right__row__headline__arrow__button_l356p {
  display: contents;
  margin-top: auto;
}
.headLines__right__row__tittle_vJR2I {
  font-size: 16px;
  font-weight: 600;
  color: #364459;
  margin-bottom: 0px;
}
.headLines__right__row__description_a7p0E {
  font-size: 16px;
  font-weight: 400;
  color: #667085;
  margin-bottom: 0px;
  text-align: justify;
}
.client__card__height_cnkeK {
  height: 360px;
}
.clients__first__left_BgtJM {
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  color: #364459;
}
.client__first__middle_ub33Q {
  text-align: end;
}
.client__first__middle__text_X62wo {
  font-size: 14px;
  font-weight: 700;
  color: #718096;
  margin-top: 15px;
}
.client__first__middle__count_CnLsN {
  font-size: 24px;
  font-weight: 700;
  color: #25396f;
  margin-top: 3px;
  margin-left: 10px;
}
.client__first__right_LReMn {
  text-align: end;
}
.client__second_mCOf1 {
  display: flex;
  flex-direction: row;
  margin-top: 10px;
  overflow-wrap: anywhere;
}
.client__second__col_GF0p8 {
  display: flex;
  justify-content: end;
  align-items: end;
  flex-direction: column;
}
.client__second__number_wgbTn {
  text-align: end;
  display: flex;
  justify-content: end;
  align-items: end;
}
.client__second__number__tag_Hh9uF {
  font-size: 10px;
  font-weight: 600;
  color: #000000 !important;
  line-height: 14px;
}
.client__second__name_EFGwr {
  font-size: 13px;
  font-weight: 500;
}
.client__third_XjaFZ {
  position: relative;
  height: 100% !important;
  width: 100% !important;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 10px;
  margin-left: 5px;
  margin-right: 5px;
}
.missingInfo__main__height_mcET2 {
  height: 360px;
}
.missingInfo__first__left_qNW1A {
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  color: #364459;
  margin-top: -10px;
}
.missingInfo__first__middle_NJjz8 {
  text-align: end;
}
.missingInfo__first__middle__text_MRtsu {
  font-size: 14px;
  font-weight: 700;
  color: #718096;
}
.missingInfo__first__middle__count_iQDZa {
  font-size: 24px;
  font-weight: 700;
  color: #25396f;
  margin-top: -5px;
}
.missingInfo__first__right_nyOeD {
  text-align: end;
}
.missingInfo__second_iVSiv {
  margin-top: 20px;
}
.missingInfo__second__row_oqXbD {
  font: caption;
  display: flex;
  align-items: center;
  justify-content: center;
}
.missingInfo__second__row__first__col_dT1Q6 {
  font-size: 14px;
  color: #2c4360;
  font-weight: 500;
  line-height: 17px;
}
.missingInfo__second__row__second__col_wlvbh {
  text-align: end;
  font-size: 14px;
  color: #2c4360;
  font-weight: 500;
  line-height: 22px;
}
.icController__main__height_mjXOS {
  height: 360px;
}
.icController__select_yfNPg {
  background-color: #f6f6f6;
  border-radius: 10px;
}
.icController__first_VnzTx {
  display: flex;
  align-items: center;
}
.icController__first__tittle_W07ZE {
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  color: #364459;
}
.icController__second_aJ5Yd {
  display: flex;
  align-items: center;
}
.icController__third_adUpK {
  display: flex;
  align-items: center;
  justify-content: end;
}
.icController__chart__first_KXBFD {
  margin-top: 10px;
  align-content: center;
  position: relative;
  width: 100%;
  height: 100%;
  top: 0%;
  left: 0%;
}
.icController__chart__second_MfxfI {
  width: 100%;
  display: flex;
  justify-content: center;
  flex-wrap: nowrap;
  margin-top: 10px;
}
.icController__chart__second__col_zPCVl {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0 10px;
}
.icController__chart__second__col__firstDiv_RWWxC {
  font-size: 13px;
  font-weight: 400;
  color: #83838d;
  text-align: center;
}
.icController__chart__second__col__secondDiv_jtlAa {
  font-size: 20px;
  font-weight: 500;
  color: #47484a;
  text-align: center;
}
.todo__main__height_ca1Id {
  height: 800px;
}
.todo__tab__one_f67DS {
  margin-top: 20px;
}
.todo__tab__one__tag_tdCPX {
  width: 70px;
  height: 20px;
  color: #364459;
  text-align: center;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
}
.todo__tab__one__badge_NSCD1 {
  height: 10px;
  color: #364459;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
}
.todo__tab__two__main__active_mZPES {
  font-size: 13px;
  font-weight: 600;
  line-height: 20px;
  color: #306bff;
  cursor: pointer;
}
.todo__tab__two__main__inactive_R8lB4 {
  font-size: 13px;
  font-weight: 400;
  line-height: 20px;
  color: #a0aec0;
  cursor: pointer;
}
.todo__tab__two__main__right_nJal1 {
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: #306bff;
  text-align: end;
  cursor: pointer;
}
.todo__list__main_awSCT {
  width: 100%;
  margin-top: 10px;
}
.todo__list__main__item__main_CBmkB {
  width: 100%;
}
.todo__list__main__item__main__tittle_Ex2zc {
  width: 100%;
  font-size: 14px;
  font-weight: 600;
  color: #364459;
}
.todo__list__main__item__main__first__content_ZjM3S {
  width: 100%;
  font-size: 12px;
  font-weight: 400;
  color: #718096;
  margin-bottom: 6px;
  margin-top: 6px;
}
.todo__list__second__item__tittle_SmiSQ {
  width: 100%;
  font-size: 12px;
  font-weight: 400;
  color: #718096;
  margin-bottom: 6px;
  margin-top: 6px;
}
.todo__list__third__item__first__tittle_e_ItH {
  width: 100%;
  font-size: 10px;
  font-weight: 400;
  color: #718096;
}
.todo__list__third__item__second__tittle_xHDdX {
  display: flex;
  flex-direction: row;
  width: 100%;
  font-size: 10px;
  font-weight: 400;
  color: #718096;
}
.todo__last__item__main_TTv0Q {
  display: flex;
  flex-direction: column;
  text-align: end;
}
.todo__last__item__button_iuk60 {
  border-radius: 10px;
  font-size: 11px;
  font-weight: 500;
  line-height: 23px;
  align-self: flex-end;
}
.todo__last__item__icons_SCtPM {
  margin-top: 5px;
}
.toFollow__main__height_DDdny {
  height: 440px;
}
.toFollow__select_eQeIM {
  width: 120px;
  background-color: #f6f6f6;
  border-radius: 10px;
}
.toFollow__viewAll_KQoX9 {
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: #306bff;
  text-align: end;
  cursor: pointer;
}
.toFollow__tab__active_J2QcJ {
  font-size: 13px;
  font-weight: 400;
  color: #ffffff;
}
.toFollow__tag__active_Zcv9r {
  background-color: #3e8eff;
}
.toFollow__tab__inactive_KW4SN {
  font-size: 13px;
  font-weight: 400;
  color: #1a1d3c;
  padding: 2px !important;
}
.toFollow__chart__main_hcdH9 {
  margin-top: 10px;
  align-content: center;
  position: relative;
  width: 100%;
  height: 200px;
  top: 0%;
  left: 0%;
}
.toFollow__chart__text_Fjhyb {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 20px;
  font-weight: 500;
  color: #364459;
}
.staffProgress__main__height_r4pXM {
  height: auto;
}
.staffProgress__tittle_z3onN {
  font-size: 20px;
  font-weight: 600;
  color: #364459;
  line-height: 32px;
}
.staffProgress__viewall_DisPS {
  font-size: 14px;
  font-weight: 500;
  color: #306bff;
  line-height: 20px;
  align-self: center;
  text-align: end;
  cursor: pointer;
}
.staffProgress__table_aPWHK {
  margin-top: 10px;
  width: 100%;
}
.staffProgress__search_lQGVK {
  width: 350px;
  margin-top: 10px;
  border-radius: 100px;
}
.staffProgress__search_lQGVK input,
.staffProgress__search_lQGVK button {
  background: #eeeff2;
}
.staffProgress__table__tittle_hYh_O {
  font-size: 14px;
  font-weight: 600;
  color: #444b50;
  text-align: center !important;
}
.calender__main__height_vFoTy {
  height: 420px;
}
.calender__tittle__main_wGLxS {
  display: flex;
  flex-direction: row;
}
.calender__tittle__header1_LxsSL {
  font-size: 20px;
  font-weight: 700;
  line-height: 18px;
}
.calender__tittle__header2_a0EPn {
  font-size: 20px;
  font-weight: 400;
  line-height: 18px;
}
.calender__list__item_Lw2WO {
  display: block !important;
  padding: 10px !important;
  margin: 5px;
  background-color: #f0f6ff;
}
.calender__list__item__time__col_cNmeI {
  display: flex;
  flex-direction: row;
}
.calender__list__item__time__value_ZYJT5 {
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
  color: #8f9bb3;
  align-self: center;
}
.calender__list__item__tittle__value_Gj9ro {
  font-size: 16px;
  font-weight: 500;
  line-height: 19px;
  color: #364459;
}
.calender__list__item__sub__tittle__value_Z0p1s {
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
  color: #8f9bb3;
  margin-top: 6px;
}
.calender__tag_nuTvO {
  border-radius: 10px;
}
.myTask__tittle_gIo6B {
  font-size: 20px;
  line-height: 24px;
  font-weight: 600;
  color: #364459;
}
.myTask__add_SK8Ip {
  font-size: 14px;
  font-weight: 500;
  color: #ffffff;
  background-color: #306bff;
}
.myTask__select_bLYL7 {
  width: 120px;
  background-color: #f6f6f6;
  border-radius: 10px;
}
.myTask__viewall_aHSTU {
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: #306bff;
  text-align: center;
}
.myTask__list__item_vkcnD {
  display: block !important;
  padding: 10px !important;
  margin: 5px 0px !important;
  background-color: #f0f6ff;
  border-radius: 10px;
  border: 0px;
  overflow-x: hidden !important;
}
.myTask__list__item__tittle_opUz0 {
  font-size: 16px;
  font-weight: 500;
  line-height: 19px;
  color: #364459;
}
.myTask__list__item__tag__one_x0YCW {
  font-size: 12px;
  font-weight: 400;
  color: #ffffff;
  border-radius: 10px;
}
.myTask__list__item__status_VcKaI {
  display: flex;
  flex-direction: row;
  font-size: 12px;
  font-weight: 400;
  color: #b3b3b3;
}
.myTask__list__item__dot_esX19 {
  border-radius: 10px;
  height: 10px;
  width: 10px;
  place-self: center;
}
.myTask__list__itme__complete__status_oz_V0 {
  font-size: 11px;
  font-weight: 400;
  color: #344054 !important;
  border: 1px Solid #d0d5dd !important;
  padding: 1.5px 6px;
  border-radius: 8px;
}
.mobileRequest__tittle_xXIpV {
  font-size: 20px;
  font-weight: 600;
  align-self: center;
}
.mobileRequest__viewall_PjyoM {
  font-size: 14px;
  font-weight: 500;
  color: #306bff;
  text-align: right;
  align-self: center;
}
.moblieRequest__list__item_bJgeU {
  display: block !important;
  padding: 10px !important;
  margin: 5px;
  background-color: #f0f6ff;
}
.moblieRequest__list__item__dot_nWtXI {
  border-radius: 10px;
  height: 10px;
  width: 10px;
  place-self: center;
}
.moblieRequest__list__item__tittle__main_FabYu {
  display: flex;
  flex-direction: row;
}
.moblieRequest__list__item__tittle_dLYp2 {
  font-size: 14px;
  font-weight: 600;
  line-height: 17px;
}
.moblieRequest__list__item__subtsittle__main_hpztW {
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
  color: #718096;
  margin-top: 8px;
}
.moblieRequest__list__item__subtsittle__col_CnhxI {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.moblieRequest__list__item__subtsittle_Vr5UP {
  font-size: 14px;
  font-weight: 600;
  color: #364459;
}
.toApprove__tittle_z2P90 {
  font-size: 20px;
  font-weight: 600;
  align-self: center;
}
.project__viewall_Rr97W {
  font-size: 14px;
  font-weight: 500;
  color: #306bff;
  text-align: right;
  align-self: center;
  cursor: pointer;
  -webkit-text-decoration: dotted underline;
          text-decoration: dotted underline;
}
.project__viewallcomplate_wCmKi {
  font-size: 12px;
}
.toApprove__list__item_IpqHB {
  display: block !important;
  padding: 10px !important;
  margin: 5px;
  border-radius: 8px;
  background-color: #ffffff;
  border: 1px solid #e1e6f0;
}
.toApprove__list__item__permission_Bnn5J {
  display: block !important;
  padding: 10px !important;
  margin: 5px;
  border-radius: 8px;
  border: 1px solid #e1e6f0;
  background-color: #ffffff;
}
.toApprove__list__item__timesheet_r7ERU {
  display: block !important;
  padding: 10px !important;
  margin: 5px;
  border-radius: 8px;
  background-color: #ffffff;
  border: 1px solid #e1e6f0;
}
.toApprove__list__item__tittle_5E5UB {
  font-size: 15px;
  font-weight: 500;
  line-height: 15px;
  color: #383853;
  margin-left: 10px;
}
.toApprove__list__item__reason_O72UJ {
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  margin-top: 5px;
  color: #36445980;
  margin-left: 10px;
}
.toApprove__list__item__leavetype_t3Y9T {
  font-size: 12px;
  font-weight: 500;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  color: #4d5770;
  background-color: #f3f8ff;
}
.toApprove__list__item__leaveday_vF7y2 {
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  background-color: #f3f8ff;
  color: #4d5770;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
}
.toApprove__list__item__timesheet__duration_I9aac {
  font-size: 12px;
  font-weight: 500;
  border: none;
  border-radius: 4px;
  background-color: #cee3c4;
  color: #316419;
}
.toApprove__list__item__button__main_qjSXy {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 5px;
}
.toApprove__list__item__button__approve_A9onM {
  background-color: #1a7f4f !important;
  border-radius: 4px;
  font-size: 11px;
  color: #ffffff;
}
.toApprove__list__item__button__approve_A9onM:hover {
  background-color: white !important;
  color: black !important;
  border-color: green !important;
}
.toApprove__list__item__button__cancel_KV0SP {
  background-color: #a61d24 !important;
  border-radius: 4px;
  font-size: 11px;
  color: #ffffff;
}
.toApprove__list__item__button__cancel_KV0SP:hover {
  background-color: white !important;
  color: black !important;
  border-color: #ec2d38 !important;
}
.client__card__button_TmJTQ {
  background-color: #1f6edc;
  border-radius: 10px;
  font-size: 11px;
  color: #ffffff;
}
.client__card__buttonInactive_JQxhj {
  border-radius: 10px;
  font-optical-sizing: 11px;
}
.flexContainer_PlCnX {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.custom_table_iFpDR td {
  text-align: center;
}
.custom_table_iFpDR th {
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Dashboard/index.less"],"names":[],"mappings":"AAEA;EACI,gBAAA;EACA,WAAA;AADJ;AAIA;EACI,aAAA;AAFJ;AAKA;EACI,aAAA;EACA,sBAAA;AAHJ;AAMA;EACI,gBAAA;AAJJ;AAOA;EACI,eAAA;AALJ;AAQA;EACI,kBAAA;AANJ;AASA;EACI,iBAAA;AAPJ;AAUA;EACI,aAAA;AARJ;AAWA;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AATJ;AAYA;EACI,iBAAA;AAVJ;AAcA;EACI,8BAAA;AAZJ;AAeA;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;AAbJ;AAgBA;EACI,eAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;AAdJ;AAiBA;EACI,eAAA;EACA,cAAA;EACA,gBAAA;AAfJ;AAkBA;EACI,eAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;AAhBJ;AAoBA;EACI,yBAAA;EACA,mBAAA;AAlBJ;AAqBA;EACI,WAAA;EACA,iBAAA;AAnBJ;AAsBA;EACI,uEAAA;EACA,YAAA;EACA,WAAA;AApBJ;AAuBA;EACI,gBAAA;EACA,eAAA;EACA,cAAA;AArBJ;AAwBA;EACI,WAAA;EACA,iBAAA;EACA,iBAAA;AAtBJ;AAyBA;EACI,gBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;AAvBJ;AA0BA;EACI,gBAAA;EACA,cAAA;AAxBJ;AA2BA;EACI,iBAAA;AAzBJ;AA4BA;EACI,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;AA1BJ;AA6BA;EACI,eAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;AA3BJ;AA8BA;EACI,kBAAA;EACA,UAAA;EACA,QAAA;AA5BJ;AA+BA;EACI,iBAAA;EACA,gBAAA;AA7BJ;AAgCA;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AA9BJ;AAiCA;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AA/BJ;AAoCA;EACI,aAAA;AAlCJ;AAqCA;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AAnCJ;AAsCA;EACI,eAAA;AApCJ;AAuCA;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AArCJ;AAwCA;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AAtCJ;AAyCA;EACI,eAAA;AAvCJ;AA0CA;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAxCJ;AA2CA;EACI,aAAA;EACA,oBAAA;EACA,gBAAA;EACA,sBAAA;AAzCJ;AA4CA;EACI,eAAA;EACA,aAAA;EACA,oBAAA;EACA,gBAAA;AA1CJ;AA6CA;EACI,eAAA;EACA,gBAAA;EAEA,yBAAA;EACA,iBAAA;AA5CJ;AA+CA;EACI,eAAA;EACA,gBAAA;AA7CJ;AAgDA;EACI,kBAAA;EACA,uBAAA;EACA,sBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;AA9CJ;AAmDA;EACI,aAAA;AAjDJ;AAoDA;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;AAlDJ;AAqDA;EACI,eAAA;AAnDJ;AAsDA;EACI,eAAA;EACA,gBAAA;EACA,cAAA;AApDJ;AAuDA;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AArDJ;AAwDA;EACI,eAAA;AAtDJ;AAyDA;EACI,gBAAA;AAvDJ;AA0DA;EACI,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAxDJ;AA2DA;EACI,eAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;AAzDJ;AA4DA;EACI,eAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;AA1DJ;AA+DA;EACI,aAAA;AA7DJ;AAgEA;EACI,yBAAA;EACA,mBAAA;AA9DJ;AAiEA;EACI,aAAA;EACA,mBAAA;AA/DJ;AAkEA;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AAhEJ;AAmEA;EACI,aAAA;EACA,mBAAA;AAjEJ;AAoEA;EACI,aAAA;EACA,mBAAA;EACA,oBAAA;AAlEJ;AAqEA;EACI,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,QAAA;AAnEJ;AAsEA;EACI,WAAA;EACA,aAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;AApEJ;AAuEA;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,cAAA;AArEJ;AAwEA;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAtEJ;AAyEA;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAvEJ;AA4EA;EACI,aAAA;AA1EJ;AA6EA;EACI,gBAAA;AA3EJ;AA8EA;EACI,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AA5EJ;AA+EA;EACI,YAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AA7EJ;AAgFA;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AA9EJ;AAiFA;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AA/EJ;AAkFA;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;AAhFJ;AAmFA;EACI,WAAA;EACA,gBAAA;AAjFJ;AAoFA;EACI,WAAA;AAlFJ;AAqFA;EACI,WAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAnFJ;AAsFA;EACI,WAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;AApFJ;AAuFA;EACI,WAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;AArFJ;AAwFA;EACI,WAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAtFJ;AAyFA;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAvFJ;AA0FA;EACI,aAAA;EACA,sBAAA;EACA,eAAA;AAxFJ;AA2FA;EACI,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;AAzFJ;AA4FA;EACI,eAAA;AA1FJ;AA+FA;EACI,aAAA;AA7FJ;AAgGA;EACI,YAAA;EACA,yBAAA;EACA,mBAAA;AA9FJ;AAiGA;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;AA/FJ;AAkGA;EACI,eAAA;EACA,gBAAA;EACA,cAAA;AAhGJ;AAkGA;EACI,yBAAA;AAhGJ;AAmGA;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,uBAAA;AAjGJ;AAoGA;EACI,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,OAAA;EACA,QAAA;AAlGJ;AAqGA;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAnGJ;AAwGA;EACI,YAAA;AAtGJ;AAyGA;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AAvGJ;AA0GA;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;AAxGJ;AA2GA;EACI,gBAAA;EACA,WAAA;AAzGJ;AA4GA;EACI,YAAA;EACA,gBAAA;EACA,oBAAA;AA1GJ;AAuGA;;EAMQ,mBAAA;AAzGR;AA6GA;EACI,eAAA;EACA,gBAAA;EAEA,cAAA;EACA,6BAAA;AA5GJ;AAiHA;EACI,aAAA;AA/GJ;AAkHA;EACI,aAAA;EACA,mBAAA;AAhHJ;AAmHA;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;AAjHJ;AAoHA;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;AAlHJ;AAqHA;EACI,yBAAA;EACA,wBAAA;EACA,WAAA;EACA,yBAAA;AAnHJ;AAsHA;EACI,aAAA;EACA,mBAAA;AApHJ;AAuHA;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AArHJ;AAwHA;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AAtHJ;AAyHA;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AAvHJ;AA0HA;EACI,mBAAA;AAxHJ;AA4HA;EACI,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AA1HJ;AA6HA;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;AA3HJ;AA8HA;EACI,YAAA;EACA,yBAAA;EACA,mBAAA;AA5HJ;AA+HA;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AA7HJ;AAgIA;EACI,yBAAA;EACA,wBAAA;EACA,0BAAA;EACA,yBAAA;EACA,mBAAA;EACA,WAAA;EACA,6BAAA;AA9HJ;AAiIA;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AA/HJ;AAkIA;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAhIJ;AAmIA;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAjIJ;AAoIA;EACI,mBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;AAlIJ;AAqIA;EACI,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,oCAAA;EACA,kBAAA;EACA,kBAAA;AAnIJ;AAwIA;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;AAtIJ;AAyIA;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;AAvIJ;AA0IA;EACI,yBAAA;EACA,wBAAA;EACA,WAAA;EACA,yBAAA;AAxIJ;AA2IA;EACI,mBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;AAzIJ;AA4IA;EACI,aAAA;EACA,mBAAA;AA1IJ;AA6IA;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;AA3IJ;AA8IA;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AA5IJ;AA+IA;EACI,aAAA;EACA,mBAAA;EACA,yBAAA;AA7IJ;AAgJA;EACI,eAAA;EACA,gBAAA;EACA,cAAA;AA9IJ;AAmJA;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;AAjJJ;AAoJA;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,yCAAA;UAAA,iCAAA;AAlJJ;AAoJA;EACI,eAAA;AAlJJ;AAqJA;EACI,yBAAA;EACA,wBAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;AAnJJ;AAsJA;EACI,yBAAA;EACA,wBAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;AApJJ;AAuJA;EACI,yBAAA;EACA,wBAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;AArJJ;AAuJA;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;AArJJ;AAwJA;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAtJJ;AAyJA;EACI,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,yBAAA;AAvJJ;AA0JA;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;AAxJJ;AA2JA;EACI,eAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;AAzJJ;AA4JA;EACI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;AA1JJ;AA6JA;EACI,oCAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;AA3JJ;AA6JA;EACI,kCAAA;EACA,uBAAA;EACA,8BAAA;AA3JJ;AA8JA;EACI,oCAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;AA5JJ;AA8JA;EACI,kCAAA;EACA,uBAAA;EACA,gCAAA;AA5JJ;AA8JA;EACI,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;AA5JJ;AA8JA;EACI,mBAAA;EACA,yBAAA;AA5JJ;AA8JA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;AA5JJ;AA+JA;EACI,kBAAA;AA7JJ;AAgKA;EACI,kBAAA;AA9JJ","sourcesContent":["// commont css\n\n.card {\n    margin-top: 10px;\n    width: 100%;\n}\n\n.cardContent {\n    margin: -10px;\n}\n\n.col {\n    display: flex;\n    flex-direction: column;\n}\n\n.marginTop10 {\n    margin-top: 10px;\n}\n\n.marginTop5 {\n    margin-top: 5px;\n}\n\n.marginRight10 {\n    margin-right: 10px;\n}\n\n.marginLeft10 {\n    margin-left: 10px;\n}\n\n.displayflex {\n    display: flex;\n}\n\n.tittle {\n    font-size: 24px;\n    font-weight: 600;\n    color: #3a3541;\n    margin-top: 0px;\n}\n\n.textAlignRight {\n    text-align: right;\n}\n\n// welcome component css\n.welcome {\n    justify-content: space-between;\n}\n\n.welcome__div {\n    display: flex;\n    flex-direction: row;\n    margin-top: 0px;\n    font-size: 18px;\n    margin-bottom: 5px;\n}\n\n.welcome__div__largeText {\n    font-size: 18px;\n    color: #000000;\n    font-weight: 600;\n    margin: auto;\n}\n\n.welcome__div__largeText_name {\n    font-size: 18px;\n    color: #3e8eff;\n    font-weight: 400;\n}\n\n.welcome__div__smallText {\n    font-size: 14px;\n    color: #000000;\n    font-weight: 500;\n    margin: auto;\n}\n\n// headLines component css\n.headLines__left {\n    background-color: #2c4360;\n    border-radius: 10px;\n}\n\n.headLines__left__textDivOne {\n    width: 100%;\n    margin-left: 10px;\n}\n\n.headLines__left__textDiv__backgroundImage {\n    background: url('../../Assest/Svg/DashboardWelcomeImg.svg') no-repeat -75% 140%;\n    height: 100%;\n    width: 100%;\n}\n\n.headLines__left__textDivOne_text {\n    font-weight: 500;\n    font-size: 16px;\n    color: #ffffff;\n}\n\n.headLines__left__textDivTwo {\n    width: 100%;\n    margin-left: 10px;\n    margin-top: -10px;\n}\n\n.headLines__left__textDivTwo_text {\n    font-weight: 500;\n    font-size: 12px;\n    color: #ffffff;\n    text-align: justify;\n}\n\n.headLines__left__textDivOne__text__name {\n    font-weight: 700;\n    color: #ffc061;\n}\n\n.headLines__right {\n    max-height: 124px;\n}\n\n.headLines__right__row {\n    display: flex;\n    flex-direction: column;\n    align-items: start;\n    justify-content: start;\n    margin-left: 20px;\n    margin-bottom: 0px;\n}\n\n.headLines__right__row__headline {\n    font-size: 20px;\n    font-weight: 600;\n    margin-top: 0px;\n    margin-bottom: 0px;\n    color: #25396f;\n    line-height: 32px;\n}\n\n.headLines__right__row__headline__arrow {\n    position: absolute;\n    right: 0px;\n    top: 2px;\n}\n\n.headLines__right__row__headline__arrow__button {\n    display: contents;\n    margin-top: auto;\n}\n\n.headLines__right__row__tittle {\n    font-size: 16px;\n    font-weight: 600;\n    color: #364459;\n    margin-bottom: 0px;\n}\n\n.headLines__right__row__description {\n    font-size: 16px;\n    font-weight: 400;\n    color: #667085;\n    margin-bottom: 0px;\n    text-align: justify;\n}\n\n//clients component css\n\n.client__card__height {\n    height: 360px;\n}\n\n.clients__first__left {\n    font-size: 18px;\n    font-weight: 600;\n    line-height: 24px;\n    color: #364459;\n}\n\n.client__first__middle {\n    text-align: end;\n}\n\n.client__first__middle__text {\n    font-size: 14px;\n    font-weight: 700;\n    color: #718096;\n    margin-top: 15px;\n}\n\n.client__first__middle__count {\n    font-size: 24px;\n    font-weight: 700;\n    color: #25396f;\n    margin-top: 3px;\n    margin-left: 10px;\n}\n\n.client__first__right {\n    text-align: end;\n}\n\n.client__second {\n    display: flex;\n    flex-direction: row;\n    margin-top: 10px;\n    overflow-wrap: anywhere;\n}\n\n.client__second__col {\n    display: flex;\n    justify-content: end;\n    align-items: end;\n    flex-direction: column;\n}\n\n.client__second__number {\n    text-align: end;\n    display: flex;\n    justify-content: end;\n    align-items: end;\n}\n\n.client__second__number__tag {\n    font-size: 10px;\n    font-weight: 600;\n    //border-radius: 10px;\n    color: #000000 !important;\n    line-height: 14px;\n}\n\n.client__second__name {\n    font-size: 13px;\n    font-weight: 500;\n}\n\n.client__third {\n    position: relative;\n    height: 100% !important;\n    width: 100% !important;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding-top: 10px;\n    margin-left: 5px;\n    margin-right: 5px;\n}\n\n//Missing Info Component CSS\n\n.missingInfo__main__height {\n    height: 360px;\n}\n\n.missingInfo__first__left {\n    font-size: 18px;\n    font-weight: 600;\n    line-height: 24px;\n    color: #364459;\n    margin-top: -10px;\n}\n\n.missingInfo__first__middle {\n    text-align: end;\n}\n\n.missingInfo__first__middle__text {\n    font-size: 14px;\n    font-weight: 700;\n    color: #718096;\n}\n\n.missingInfo__first__middle__count {\n    font-size: 24px;\n    font-weight: 700;\n    color: #25396f;\n    margin-top: -5px;\n}\n\n.missingInfo__first__right {\n    text-align: end;\n}\n\n.missingInfo__second {\n    margin-top: 20px;\n}\n\n.missingInfo__second__row {\n    font: caption;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.missingInfo__second__row__first__col {\n    font-size: 14px;\n    color: #2c4360;\n    font-weight: 500;\n    line-height: 17px;\n}\n\n.missingInfo__second__row__second__col {\n    text-align: end;\n    font-size: 14px;\n    color: #2c4360;\n    font-weight: 500;\n    line-height: 22px;\n}\n\n//Invoice and credit controller CSS\n\n.icController__main__height {\n    height: 360px;\n}\n\n.icController__select {\n    background-color: #f6f6f6;\n    border-radius: 10px;\n}\n\n.icController__first {\n    display: flex;\n    align-items: center;\n}\n\n.icController__first__tittle {\n    font-size: 18px;\n    font-weight: 600;\n    line-height: 24px;\n    color: #364459;\n}\n\n.icController__second {\n    display: flex;\n    align-items: center;\n}\n\n.icController__third {\n    display: flex;\n    align-items: center;\n    justify-content: end;\n}\n\n.icController__chart__first {\n    margin-top: 10px;\n    align-content: center;\n    position: relative;\n    width: 100%;\n    height: 100%;\n    top: 0%;\n    left: 0%;\n}\n\n.icController__chart__second {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    flex-wrap: nowrap;\n    margin-top: 10px;\n}\n\n.icController__chart__second__col {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    margin: 0 10px;\n}\n\n.icController__chart__second__col__firstDiv {\n    font-size: 13px;\n    font-weight: 400;\n    color: #83838d;\n    text-align: center;\n}\n\n.icController__chart__second__col__secondDiv {\n    font-size: 20px;\n    font-weight: 500;\n    color: #47484a;\n    text-align: center;\n}\n\n// To do Component CSS\n\n.todo__main__height {\n    height: 800px;\n}\n\n.todo__tab__one {\n    margin-top: 20px;\n}\n\n.todo__tab__one__tag {\n    width: 70px;\n    height: 20px;\n    color: #364459;\n    text-align: center;\n    border-radius: 10px;\n    font-size: 14px;\n    font-weight: 600;\n}\n\n.todo__tab__one__badge {\n    height: 10px;\n    color: #364459;\n    font-size: 14px;\n    font-weight: 600;\n    text-align: center;\n}\n\n.todo__tab__two__main__active {\n    font-size: 13px;\n    font-weight: 600;\n    line-height: 20px;\n    color: #306bff;\n    cursor: pointer;\n}\n\n.todo__tab__two__main__inactive {\n    font-size: 13px;\n    font-weight: 400;\n    line-height: 20px;\n    color: #a0aec0;\n    cursor: pointer;\n}\n\n.todo__tab__two__main__right {\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 20px;\n    color: #306bff;\n    text-align: end;\n    cursor: pointer;\n}\n\n.todo__list__main {\n    width: 100%;\n    margin-top: 10px;\n}\n\n.todo__list__main__item__main {\n    width: 100%;\n}\n\n.todo__list__main__item__main__tittle {\n    width: 100%;\n    font-size: 14px;\n    font-weight: 600;\n    color: #364459;\n}\n\n.todo__list__main__item__main__first__content {\n    width: 100%;\n    font-size: 12px;\n    font-weight: 400;\n    color: #718096;\n    margin-bottom: 6px;\n    margin-top: 6px;\n}\n\n.todo__list__second__item__tittle {\n    width: 100%;\n    font-size: 12px;\n    font-weight: 400;\n    color: #718096;\n    margin-bottom: 6px;\n    margin-top: 6px;\n}\n\n.todo__list__third__item__first__tittle {\n    width: 100%;\n    font-size: 10px;\n    font-weight: 400;\n    color: #718096;\n}\n\n.todo__list__third__item__second__tittle {\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n    font-size: 10px;\n    font-weight: 400;\n    color: #718096;\n}\n\n.todo__last__item__main {\n    display: flex;\n    flex-direction: column;\n    text-align: end;\n}\n\n.todo__last__item__button {\n    border-radius: 10px;\n    font-size: 11px;\n    font-weight: 500;\n    line-height: 23px;\n    align-self: flex-end;\n}\n\n.todo__last__item__icons {\n    margin-top: 5px;\n}\n\n//To Follow Css\n\n.toFollow__main__height {\n    height: 440px;\n}\n\n.toFollow__select {\n    width: 120px;\n    background-color: #f6f6f6;\n    border-radius: 10px;\n}\n\n.toFollow__viewAll {\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 20px;\n    color: #306bff;\n    text-align: end;\n    cursor: pointer;\n}\n\n.toFollow__tab__active {\n    font-size: 13px;\n    font-weight: 400;\n    color: #ffffff;\n}\n.toFollow__tag__active {\n    background-color: #3e8eff;\n}\n\n.toFollow__tab__inactive {\n    font-size: 13px;\n    font-weight: 400;\n    color: #1a1d3c;\n    padding: 2px !important;\n}\n\n.toFollow__chart__main {\n    margin-top: 10px;\n    align-content: center;\n    position: relative;\n    width: 100%;\n    height: 200px;\n    top: 0%;\n    left: 0%;\n}\n\n.toFollow__chart__text {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    font-size: 20px;\n    font-weight: 500;\n    color: #364459;\n}\n\n//staff progress css\n\n.staffProgress__main__height {\n    height: auto;\n}\n\n.staffProgress__tittle {\n    font-size: 20px;\n    font-weight: 600;\n    color: #364459;\n    line-height: 32px;\n}\n\n.staffProgress__viewall {\n    font-size: 14px;\n    font-weight: 500;\n    color: #306bff;\n    line-height: 20px;\n    align-self: center;\n    text-align: end;\n    cursor: pointer;\n}\n\n.staffProgress__table {\n    margin-top: 10px;\n    width: 100%;\n}\n\n.staffProgress__search {\n    width: 350px;\n    margin-top: 10px;\n    border-radius: 100px;\n    input,\n    button {\n        background: #eeeff2;\n    }\n}\n\n.staffProgress__table__tittle {\n    font-size: 14px;\n    font-weight: 600;\n    // line-height: 24px;\n    color: #444b50;\n    text-align: center !important;\n}\n\n// calender component Css\n\n.calender__main__height {\n    height: 420px;\n}\n\n.calender__tittle__main {\n    display: flex;\n    flex-direction: row;\n}\n\n.calender__tittle__header1 {\n    font-size: 20px;\n    font-weight: 700;\n    line-height: 18px;\n}\n\n.calender__tittle__header2 {\n    font-size: 20px;\n    font-weight: 400;\n    line-height: 18px;\n}\n\n.calender__list__item {\n    display: block !important;\n    padding: 10px !important;\n    margin: 5px;\n    background-color: #f0f6ff;\n}\n\n.calender__list__item__time__col {\n    display: flex;\n    flex-direction: row;\n}\n\n.calender__list__item__time__value {\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 14px;\n    color: #8f9bb3;\n    align-self: center;\n}\n\n.calender__list__item__tittle__value {\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 19px;\n    color: #364459;\n}\n\n.calender__list__item__sub__tittle__value {\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 14px;\n    color: #8f9bb3;\n    margin-top: 6px;\n}\n\n.calender__tag {\n    border-radius: 10px;\n}\n\n//myTask Component Css\n.myTask__tittle {\n    font-size: 20px;\n    line-height: 24px;\n    font-weight: 600;\n    color: #364459;\n}\n\n.myTask__add {\n    font-size: 14px;\n    font-weight: 500;\n    color: #ffffff;\n    background-color: #306bff;\n}\n\n.myTask__select {\n    width: 120px;\n    background-color: #f6f6f6;\n    border-radius: 10px;\n}\n\n.myTask__viewall {\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 20px;\n    color: #306bff;\n    text-align: center;\n}\n\n.myTask__list__item {\n    display: block !important;\n    padding: 10px !important;\n    margin: 5px 0px !important;\n    background-color: #f0f6ff;\n    border-radius: 10px;\n    border: 0px;\n    overflow-x: hidden !important;\n}\n\n.myTask__list__item__tittle {\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 19px;\n    color: #364459;\n}\n\n.myTask__list__item__tag__one {\n    font-size: 12px;\n    font-weight: 400;\n    color: #ffffff;\n    border-radius: 10px;\n}\n\n.myTask__list__item__status {\n    display: flex;\n    flex-direction: row;\n    font-size: 12px;\n    font-weight: 400;\n    color: #b3b3b3;\n}\n\n.myTask__list__item__dot {\n    border-radius: 10px;\n    height: 10px;\n    width: 10px;\n    place-self: center;\n}\n\n.myTask__list__itme__complete__status {\n    font-size: 11px;\n    font-weight: 400;\n    color: #344054 !important;\n    border: 1px Solid #d0d5dd !important;\n    padding: 1.5px 6px;\n    border-radius: 8px;\n}\n\n//mobile Request Component Css\n\n.mobileRequest__tittle {\n    font-size: 20px;\n    font-weight: 600;\n    align-self: center;\n}\n\n.mobileRequest__viewall {\n    font-size: 14px;\n    font-weight: 500;\n    color: #306bff;\n    text-align: right;\n    align-self: center;\n}\n\n.moblieRequest__list__item {\n    display: block !important;\n    padding: 10px !important;\n    margin: 5px;\n    background-color: #f0f6ff;\n}\n\n.moblieRequest__list__item__dot {\n    border-radius: 10px;\n    height: 10px;\n    width: 10px;\n    place-self: center;\n}\n\n.moblieRequest__list__item__tittle__main {\n    display: flex;\n    flex-direction: row;\n}\n\n.moblieRequest__list__item__tittle {\n    font-size: 14px;\n    font-weight: 600;\n    line-height: 17px;\n}\n\n.moblieRequest__list__item__subtsittle__main {\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 14px;\n    color: #718096;\n    margin-top: 8px;\n}\n\n.moblieRequest__list__item__subtsittle__col {\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-end;\n}\n\n.moblieRequest__list__item__subtsittle {\n    font-size: 14px;\n    font-weight: 600;\n    color: #364459;\n}\n\n//To Approve Component CSS\n\n.toApprove__tittle {\n    font-size: 20px;\n    font-weight: 600;\n    align-self: center;\n}\n\n.project__viewall {\n    font-size: 14px;\n    font-weight: 500;\n    color: #306bff;\n    text-align: right;\n    align-self: center;\n    cursor: pointer;\n    text-decoration: dotted underline;\n}\n.project__viewallcomplate {\n    font-size: 12px;\n}\n\n.toApprove__list__item {\n    display: block !important;\n    padding: 10px !important;\n    margin: 5px;\n    border-radius: 8px;\n    background-color: #ffffff;\n    border: 1px solid #e1e6f0;\n}\n\n.toApprove__list__item__permission {\n    display: block !important;\n    padding: 10px !important;\n    margin: 5px;\n    border-radius: 8px;\n    border: 1px solid #e1e6f0;\n    background-color: #ffffff;\n}\n\n.toApprove__list__item__timesheet {\n    display: block !important;\n    padding: 10px !important;\n    margin: 5px;\n    border-radius: 8px;\n    background-color: #ffffff;\n    border: 1px solid #e1e6f0;\n}\n.toApprove__list__item__tittle {\n    font-size: 15px;\n    font-weight: 500;\n    line-height: 15px;\n    color: #383853;\n    margin-left: 10px;\n}\n\n.toApprove__list__item__reason {\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 18px;\n    margin-top: 5px;\n    color: #36445980;\n    margin-left: 10px;\n}\n\n.toApprove__list__item__leavetype {\n    font-size: 12px;\n    font-weight: 500;\n    border: 1px solid #e0e0e0;\n    border-radius: 4px;\n    color: #4d5770;\n    background-color: #f3f8ff;\n}\n\n.toApprove__list__item__leaveday {\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 18px;\n    background-color: #f3f8ff;\n    color: #4d5770;\n    border: 1px solid #e0e0e0;\n    border-radius: 4px;\n}\n\n.toApprove__list__item__timesheet__duration {\n    font-size: 12px;\n    font-weight: 500;\n    border: none;\n    border-radius: 4px;\n    background-color: #cee3c4;\n    color: #316419;\n}\n\n.toApprove__list__item__button__main {\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-end;\n    margin-top: 5px;\n}\n\n.toApprove__list__item__button__approve {\n    background-color: #1a7f4f !important;\n    border-radius: 4px;\n    font-size: 11px;\n    color: #ffffff;\n}\n.toApprove__list__item__button__approve:hover {\n    background-color: white !important;\n    color: black !important;\n    border-color: green !important;\n}\n\n.toApprove__list__item__button__cancel {\n    background-color: #a61d24 !important;\n    border-radius: 4px;\n    font-size: 11px;\n    color: #ffffff;\n}\n.toApprove__list__item__button__cancel:hover {\n    background-color: white !important;\n    color: black !important;\n    border-color: #ec2d38 !important;\n}\n.client__card__button {\n    background-color: #1f6edc;\n    border-radius: 10px;\n    font-size: 11px;\n    color: #ffffff;\n}\n.client__card__buttonInactive {\n    border-radius: 10px;\n    font-optical-sizing: 11px;\n}\n.flexContainer {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.custom_table td {\n    text-align: center;\n}\n\n.custom_table th {\n    text-align: center;\n}\n\n@primary-color: #2FB153;@link-color: #1DA57A;@border-radius-base: 2px;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `card_O2mpS`,
	"cardContent": `cardContent_Q7qC4`,
	"col": `col_nrFxf`,
	"marginTop10": `marginTop10_XhSDp`,
	"marginTop5": `marginTop5_Z7qm_`,
	"marginRight10": `marginRight10_mqLc4`,
	"marginLeft10": `marginLeft10_CYZrh`,
	"displayflex": `displayflex_ltmqi`,
	"tittle": `tittle_Yy0HQ`,
	"textAlignRight": `textAlignRight_hE5Na`,
	"welcome": `welcome_ESNDi`,
	"welcome__div": `welcome__div_YGwMa`,
	"welcome__div__largeText": `welcome__div__largeText_DVK_0`,
	"welcome__div__largeText_name": `welcome__div__largeText_name_tJ4AY`,
	"welcome__div__smallText": `welcome__div__smallText_bXrSy`,
	"headLines__left": `headLines__left_cW4Gw`,
	"headLines__left__textDivOne": `headLines__left__textDivOne_xM6uV`,
	"headLines__left__textDiv__backgroundImage": `headLines__left__textDiv__backgroundImage_vbp04`,
	"headLines__left__textDivOne_text": `headLines__left__textDivOne_text_ieOIV`,
	"headLines__left__textDivTwo": `headLines__left__textDivTwo_x4kVi`,
	"headLines__left__textDivTwo_text": `headLines__left__textDivTwo_text_gGk8L`,
	"headLines__left__textDivOne__text__name": `headLines__left__textDivOne__text__name_YBot4`,
	"headLines__right": `headLines__right_NdZp_`,
	"headLines__right__row": `headLines__right__row_kDro5`,
	"headLines__right__row__headline": `headLines__right__row__headline_p52ez`,
	"headLines__right__row__headline__arrow": `headLines__right__row__headline__arrow_B8g8R`,
	"headLines__right__row__headline__arrow__button": `headLines__right__row__headline__arrow__button_l356p`,
	"headLines__right__row__tittle": `headLines__right__row__tittle_vJR2I`,
	"headLines__right__row__description": `headLines__right__row__description_a7p0E`,
	"client__card__height": `client__card__height_cnkeK`,
	"clients__first__left": `clients__first__left_BgtJM`,
	"client__first__middle": `client__first__middle_ub33Q`,
	"client__first__middle__text": `client__first__middle__text_X62wo`,
	"client__first__middle__count": `client__first__middle__count_CnLsN`,
	"client__first__right": `client__first__right_LReMn`,
	"client__second": `client__second_mCOf1`,
	"client__second__col": `client__second__col_GF0p8`,
	"client__second__number": `client__second__number_wgbTn`,
	"client__second__number__tag": `client__second__number__tag_Hh9uF`,
	"client__second__name": `client__second__name_EFGwr`,
	"client__third": `client__third_XjaFZ`,
	"missingInfo__main__height": `missingInfo__main__height_mcET2`,
	"missingInfo__first__left": `missingInfo__first__left_qNW1A`,
	"missingInfo__first__middle": `missingInfo__first__middle_NJjz8`,
	"missingInfo__first__middle__text": `missingInfo__first__middle__text_MRtsu`,
	"missingInfo__first__middle__count": `missingInfo__first__middle__count_iQDZa`,
	"missingInfo__first__right": `missingInfo__first__right_nyOeD`,
	"missingInfo__second": `missingInfo__second_iVSiv`,
	"missingInfo__second__row": `missingInfo__second__row_oqXbD`,
	"missingInfo__second__row__first__col": `missingInfo__second__row__first__col_dT1Q6`,
	"missingInfo__second__row__second__col": `missingInfo__second__row__second__col_wlvbh`,
	"icController__main__height": `icController__main__height_mjXOS`,
	"icController__select": `icController__select_yfNPg`,
	"icController__first": `icController__first_VnzTx`,
	"icController__first__tittle": `icController__first__tittle_W07ZE`,
	"icController__second": `icController__second_aJ5Yd`,
	"icController__third": `icController__third_adUpK`,
	"icController__chart__first": `icController__chart__first_KXBFD`,
	"icController__chart__second": `icController__chart__second_MfxfI`,
	"icController__chart__second__col": `icController__chart__second__col_zPCVl`,
	"icController__chart__second__col__firstDiv": `icController__chart__second__col__firstDiv_RWWxC`,
	"icController__chart__second__col__secondDiv": `icController__chart__second__col__secondDiv_jtlAa`,
	"todo__main__height": `todo__main__height_ca1Id`,
	"todo__tab__one": `todo__tab__one_f67DS`,
	"todo__tab__one__tag": `todo__tab__one__tag_tdCPX`,
	"todo__tab__one__badge": `todo__tab__one__badge_NSCD1`,
	"todo__tab__two__main__active": `todo__tab__two__main__active_mZPES`,
	"todo__tab__two__main__inactive": `todo__tab__two__main__inactive_R8lB4`,
	"todo__tab__two__main__right": `todo__tab__two__main__right_nJal1`,
	"todo__list__main": `todo__list__main_awSCT`,
	"todo__list__main__item__main": `todo__list__main__item__main_CBmkB`,
	"todo__list__main__item__main__tittle": `todo__list__main__item__main__tittle_Ex2zc`,
	"todo__list__main__item__main__first__content": `todo__list__main__item__main__first__content_ZjM3S`,
	"todo__list__second__item__tittle": `todo__list__second__item__tittle_SmiSQ`,
	"todo__list__third__item__first__tittle": `todo__list__third__item__first__tittle_e_ItH`,
	"todo__list__third__item__second__tittle": `todo__list__third__item__second__tittle_xHDdX`,
	"todo__last__item__main": `todo__last__item__main_TTv0Q`,
	"todo__last__item__button": `todo__last__item__button_iuk60`,
	"todo__last__item__icons": `todo__last__item__icons_SCtPM`,
	"toFollow__main__height": `toFollow__main__height_DDdny`,
	"toFollow__select": `toFollow__select_eQeIM`,
	"toFollow__viewAll": `toFollow__viewAll_KQoX9`,
	"toFollow__tab__active": `toFollow__tab__active_J2QcJ`,
	"toFollow__tag__active": `toFollow__tag__active_Zcv9r`,
	"toFollow__tab__inactive": `toFollow__tab__inactive_KW4SN`,
	"toFollow__chart__main": `toFollow__chart__main_hcdH9`,
	"toFollow__chart__text": `toFollow__chart__text_Fjhyb`,
	"staffProgress__main__height": `staffProgress__main__height_r4pXM`,
	"staffProgress__tittle": `staffProgress__tittle_z3onN`,
	"staffProgress__viewall": `staffProgress__viewall_DisPS`,
	"staffProgress__table": `staffProgress__table_aPWHK`,
	"staffProgress__search": `staffProgress__search_lQGVK`,
	"staffProgress__table__tittle": `staffProgress__table__tittle_hYh_O`,
	"calender__main__height": `calender__main__height_vFoTy`,
	"calender__tittle__main": `calender__tittle__main_wGLxS`,
	"calender__tittle__header1": `calender__tittle__header1_LxsSL`,
	"calender__tittle__header2": `calender__tittle__header2_a0EPn`,
	"calender__list__item": `calender__list__item_Lw2WO`,
	"calender__list__item__time__col": `calender__list__item__time__col_cNmeI`,
	"calender__list__item__time__value": `calender__list__item__time__value_ZYJT5`,
	"calender__list__item__tittle__value": `calender__list__item__tittle__value_Gj9ro`,
	"calender__list__item__sub__tittle__value": `calender__list__item__sub__tittle__value_Z0p1s`,
	"calender__tag": `calender__tag_nuTvO`,
	"myTask__tittle": `myTask__tittle_gIo6B`,
	"myTask__add": `myTask__add_SK8Ip`,
	"myTask__select": `myTask__select_bLYL7`,
	"myTask__viewall": `myTask__viewall_aHSTU`,
	"myTask__list__item": `myTask__list__item_vkcnD`,
	"myTask__list__item__tittle": `myTask__list__item__tittle_opUz0`,
	"myTask__list__item__tag__one": `myTask__list__item__tag__one_x0YCW`,
	"myTask__list__item__status": `myTask__list__item__status_VcKaI`,
	"myTask__list__item__dot": `myTask__list__item__dot_esX19`,
	"myTask__list__itme__complete__status": `myTask__list__itme__complete__status_oz_V0`,
	"mobileRequest__tittle": `mobileRequest__tittle_xXIpV`,
	"mobileRequest__viewall": `mobileRequest__viewall_PjyoM`,
	"moblieRequest__list__item": `moblieRequest__list__item_bJgeU`,
	"moblieRequest__list__item__dot": `moblieRequest__list__item__dot_nWtXI`,
	"moblieRequest__list__item__tittle__main": `moblieRequest__list__item__tittle__main_FabYu`,
	"moblieRequest__list__item__tittle": `moblieRequest__list__item__tittle_dLYp2`,
	"moblieRequest__list__item__subtsittle__main": `moblieRequest__list__item__subtsittle__main_hpztW`,
	"moblieRequest__list__item__subtsittle__col": `moblieRequest__list__item__subtsittle__col_CnhxI`,
	"moblieRequest__list__item__subtsittle": `moblieRequest__list__item__subtsittle_Vr5UP`,
	"toApprove__tittle": `toApprove__tittle_z2P90`,
	"project__viewall": `project__viewall_Rr97W`,
	"project__viewallcomplate": `project__viewallcomplate_wCmKi`,
	"toApprove__list__item": `toApprove__list__item_IpqHB`,
	"toApprove__list__item__permission": `toApprove__list__item__permission_Bnn5J`,
	"toApprove__list__item__timesheet": `toApprove__list__item__timesheet_r7ERU`,
	"toApprove__list__item__tittle": `toApprove__list__item__tittle_5E5UB`,
	"toApprove__list__item__reason": `toApprove__list__item__reason_O72UJ`,
	"toApprove__list__item__leavetype": `toApprove__list__item__leavetype_t3Y9T`,
	"toApprove__list__item__leaveday": `toApprove__list__item__leaveday_vF7y2`,
	"toApprove__list__item__timesheet__duration": `toApprove__list__item__timesheet__duration_I9aac`,
	"toApprove__list__item__button__main": `toApprove__list__item__button__main_qjSXy`,
	"toApprove__list__item__button__approve": `toApprove__list__item__button__approve_A9onM`,
	"toApprove__list__item__button__cancel": `toApprove__list__item__button__cancel_KV0SP`,
	"client__card__button": `client__card__button_TmJTQ`,
	"client__card__buttonInactive": `client__card__buttonInactive_JQxhj`,
	"flexContainer": `flexContainer_PlCnX`,
	"custom_table": `custom_table_iFpDR`
};
export default ___CSS_LOADER_EXPORT___;
